import {
  Component,
  Inject,
  Input,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProductService } from '@/app/shared/services/product.service';
import { CommonService } from '@/app/shared/services/common.service';

import { Breadcrumb } from '@/app/shared/interface/breadcrumb';
import * as data from '@/app/shared/data/owl-carousel';
import { Option } from '@/app/shared/interface/common.interface';
import {
  Product,
  ProductModel,
  ProductsPaginationModel,
} from '@/app/shared/interface/product.interface';
import { SlidesOutputData } from 'ngx-owl-carousel-o';
import { firstValueFrom, Subscription } from 'rxjs';
import { SeoService } from '@/app/shared/services/seo.service';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '@/app/shared/services/auth.service';
import { VoucherService } from '@/app/shared/services/voucher.service';
import {
  ProductConditionDto,
  Voucher,
} from '@/app/shared/interface/voucher.interface';
import { Cart, CartItem } from '@/app/shared/interface/cart.interface';
import { QueryStringService } from '@/app/shared/services/querystring.service';
import { CatetoryQueryString } from '@/app/shared/filter';
import { WishlistService } from '@/app/shared/services/wishlist.service';
import { ToastrService } from 'ngx-toastr';
import { ConfigurationV2Service } from '@/app/shared/services/configuration-v2.service';
import { ListBanners, ScreenListBanner } from '@/app/shared/interface/banner.interface';
import { BANNER_TYPES, SCREENS_ID } from '@/app/shared/constants/common.constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@/environments/environment';
import { decodeHtmlEntities, htmlToText, truncateText } from '@/app/shared/seo-text';
import { TrackingService } from '@/app/shared/services/tracking.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.scss',
})
export class ProductDetailComponent {
  @ViewChild('productDetailImageModal') productDetailImageModal: any;

  @Input() option: Option | null;
  @Input() selectedVoucherCode: string[] = [];

  public cart: Cart;
  cartItem: CartItem;

  public breadcrumb: Breadcrumb = {
    title: 'Sản Phẩm',
    items: [{ label: 'Sản Phẩm', active: false, url: '/product' }],
  };

  productId: any;
  productSlug: any;
  public product: Product;
  public productSuggestions: Product[] = [];
  public productMainThumbSlider = data.productMainThumbSlider;
  public productThumbSlider = data.productThumbSlider;
  public activeSlide: string = '0';
  public isAuthenticated: boolean = false;

  public views: number = 1524;
  public isAccountActivated: boolean;

  productSuggestionIds: number[] = [];

  isBrowser: boolean = false;

  productVouchers: Voucher[] = [];

  public filter: any = {
    page: 1, // Current page number
    status: 1,
    field: '',
    price: '',
    category: '',
    tag: '',
    sort: '', // ASC, DSC
    sortBy: '',
    rating: '',
    attribute: '',
  };

  private changeQueryStringSubscription?: Subscription;
  public categoryQuery: CatetoryQueryString = new CatetoryQueryString();
  public productBanner: ListBanners | undefined;
  recentProducts: Product[] = [];
  vouchers: Voucher[] = [];

  inWishList: boolean = false;

  productSubscription: Subscription;
  cartSubscription: Subscription;
  wishlistSubscription: Subscription;
  productPolicyConfig: any[];

  isDragging: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    public commonService: CommonService,
    private seoService: SeoService,
    private authService: AuthService,
    private tracking: TrackingService,
    private voucherService: VoucherService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private queryStringService: QueryStringService,
    private router: Router,
    private wishlistService: WishlistService,
    private toastService: ToastrService,
    private configurationV2Service: ConfigurationV2Service,
    private modalService: NgbModal
  ) {
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.modalService.dismissAll();
      this.productId = params.get('id');
      this.getProductDetailBySlug();
    });

    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
      window.addEventListener('resize', () => {
        this.changeItemsPerSlide();
      });

      this.commonService.getProductPolicyConfig.subscribe(res => {
        if (res && res.length > 0) {
          this.productPolicyConfig = res;
        }
      })

      this.changeQueryStringSubscription =
        this.queryStringService.eventChangeQueryString.subscribe(() => {
          this.categoryQuery = this.queryStringService.getQueryString(
            new CatetoryQueryString(),
          );
          this.router.navigateByUrl(
            `/product?category=${this.categoryQuery.value}`,
          );
        });

      this.productService.recentProductsView$.subscribe((products) => {
        this.recentProducts = products;
      });

      // this.productSubscription = this.commonService.getProductDetail.subscribe({
      //   next: (res: any) => {
      //     if (res && res.productID) {
      //       this.product = res;
      //       this.setCartItem(this.product);
      //     }
      //   },
      // });

      this.getVoucher();
      this.getBanner();
    }
  }

  changeItemsPerSlide() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth <= 756) {
        this.productThumbSlider.responsive![0].items = 2;
      } else {
        this.productThumbSlider.responsive![0].items = 6;
      }
    }
  }

  getProductDetail() {
    this.productService.getProductById(this.productId).subscribe({
      next: (res: Product) => {
        if (res) {
          this.product = res;

          if (this.product) {
            this.setSeoConfig();
          }

          if (isPlatformBrowser(this.platformId)) {
            this.setProductDetail();
            // this.getRelevantVouchersForProduct();
            this.tracking.productViewed(this.product);
          }
        }
      },
      error: (error) => {
        // console.log(error);
      },
    });
  }

  getProductDetailBySlug() {
    // this.route.data.subscribe({
    this.productService.getProductBySlug(this.productId).subscribe({
      next: (res: any) => {
        if (res) {
          this.product = res;
          if (this.product) {
            this.setSeoConfig();
          }
          
          this.setProductDetail();
          
          if (isPlatformBrowser(this.platformId)) {
            // this.getRelevantVouchersForProduct();
            this.tracking.productViewed(this.product);
          }
        } else {
          this.getProductDetail();
        }
      },
      error: (error) => {
        this.getProductDetail();
        // console.log(error);
      },
    });
  }

  getRelevantVouchersForProduct() {
    const sku = this.product?.sku;
    const labels = this.product?.labels ?? [];
    const productId = this.product?.productID;

    const conditions: ProductConditionDto[] = [];

    if (labels.length > 0) {
      for (const label of labels) {
        if (label?.slug) {
          conditions.push({ productId, sku, label: label.slug });
        }
      }
    } else {
      if (sku) {
        conditions.push({ productId, sku });
      }
    }

    if (!conditions.length) return;

    if (this.isAuthenticated) {
      this.voucherService.getRelevantVoucherProducts(conditions).subscribe({
        next: (vouchers) => {
          const seen = new Set<string>();
          this.productVouchers = (vouchers ?? []).filter((v) => {
            if (seen.has(v.code)) return false;
            seen.add(v.code);
            return true;
          });
        },
        error: (err) => {
          console.error('Failed to fetch vouchers:', err);
        },
      });
    }
  }

  setCartItem(product: Product) {
    let cartItems = this.cart?.items.filter(
      (i: any) => i.productID === product.productID,
    );
    let cartItem = structuredClone(cartItems?.[0] ?? null);
    if (cartItem) {
      product.subProducts = cartItem.subItems;
      cartItem.quantity += cartItems
        .slice(1)
        .reduce((acc: number, curr: any) => acc + (curr.quantity ?? 0), 0);
      this.commonService.setCartItem(cartItem);
    } else {
      cartItem = {
        imgUrl: product.imageUrls[0],
        name: product.name,
        price: product.basePrice,
        basePrice: product.basePrice,
        productID: product.productID,
        quantity: 0,
        labels: product.labels,
        SKU: product.SKU,
        slug: product.slug,
        coinIconLevel: product.coinIconLevel,
        appliedPricingTable: product.appliedPricingTable,
      };
    }
    return cartItem;
  }

  async getBanner() {
    this.configurationV2Service.appBanner$.subscribe({
      next: (res: ScreenListBanner[]) => {
        if (res && res.length > 0) {
          this.productBanner =
            res
              .find(
                (item: ScreenListBanner) =>
                  item.screenId === SCREENS_ID.PRODUCT,
              )
              ?.listBanners.find(
                (group: ListBanners) => group.type === BANNER_TYPES.PRODUCT,
              ) || undefined;
        }
      },
    });
  }

  setSeoConfig() {
    const metaTitle = this.product.metaTitle || this.product.name;
    const metaTags = {
      title: metaTitle,
      metaTitle: metaTitle,
      description: this.getSeoDescription(),
      image:
        this.product.metaImages.length > 0
          ? this.product.metaImages[0]
          : this.product.imageUrls[0],
      schema: this.buildSchema(),
    };
    this.seoService.generateTags(metaTags);
  }

  // URL canonical của sản phẩm: cùng quy tắc SeoService.toCanonicalCase (path lowercase), trùng sitemap-products.xml.
  private getProductUrl(): string {
    return `${environment.site}${new URL(`/product/${this.product.slug}`, environment.site).pathname.toLowerCase()}`;
  }

  private getCommonInfoText(): string {
    const commonInfo = this.product.additionalInfo?.find(info => info.name?.trim().toLowerCase() === 'thông tin chung')?.value ?? '';
    return htmlToText(decodeHtmlEntities(commonInfo));
  }

  // JSON-LD: BreadcrumbList + Product (Drug cho danh mục thuốc). Escape "<" để dữ liệu không thể đóng thẻ <script>.
  private buildSchema(): string {
    return JSON.stringify([this.buildBreadcrumbSchema(), this.buildProductSchema()]).replace(/</g, '\\u003c');
  }

  // metaDescription rỗng => text đầu tab "Thông tin chung" (tối đa 165 ký tự, bỏ ảnh) => rỗng nữa thì tên sản phẩm.
  // Value của tab có thể chứa HTML bị escape (&lt;a ...&gt;): decode entity trước như ProductDetailsTabsComponent.decodeHtml
  // để chỉ lấy phần chữ người dùng thấy.
  private getSeoDescription(): string {
    if (this.product.metaDescription?.trim()) {
      return this.product.metaDescription;
    }
    return truncateText(this.getCommonInfoText() || this.product.metaTitle || this.product.name || '');
  }

  // BreadcrumbList khớp breadcrumb hiển thị khi SSR (Trang chủ › Sản Phẩm › tên sản phẩm).
  private buildBreadcrumbSchema(): object {
    const site = environment.site;
    const product = this.product;
    const categories = (product.categories ?? []).filter(category => category?.name?.trim());
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Trang chủ', item: `${site}/` },
        { '@type': 'ListItem', position: 2, name: this.breadcrumb.title, item: `${site}/product` },
        { '@type': 'ListItem', position: 3, name: categories.map(category => category.name).join(', '), item: `${site}/product?category=${categories.map(category => category.slug).join(',')}` },
        { '@type': 'ListItem', position: 4, name: this.product.name, item: this.getProductUrl() },
      ],
    };
  }

  // Danh mục thuốc (theo slug, nhóm "Thuốc kê đơn" / "Thuốc không kê đơn" trên menu):
  // - thuoc-...khong-ke-don... (Thuốc thường không kê đơn, Thuốc cấm sử dụng trong 1 số ngành không kê đơn) => OTC;
  // - thuoc-...ke-don... còn lại (thường / thiết yếu / cấm... / gây nghiện kê đơn) => PrescriptionOnly.
  // SP vừa có danh mục kê đơn vừa không kê đơn => PrescriptionOnly.
  // Thuốc => @type [Product, Drug], có activeIngredient ("Tên hoạt chất hàm lượng, ...") + prescriptionStatus.
  // Sản phẩm khác => Product, không có hai trường này.
  // Chưa có offers: giá chỉ hiện sau khi đăng nhập nên SSR không có giá. Trường API trống => bỏ khỏi schema.
  private buildProductSchema(): object {
    const product = this.product;
    const categories = (product.categories ?? []).filter(category => category?.name?.trim());
    const drugSlugs = categories.map(category => category.slug?.toLowerCase() ?? '').filter(slug => slug.startsWith('thuoc-'));
    const isOtc = drugSlugs.some(slug => slug.includes('khong-ke-don'));
    const isPrescription = drugSlugs.some(slug => slug.includes('ke-don') && !slug.includes('khong-ke-don'));
    const isDrug = isOtc || isPrescription;
    const prescriptionStatus = isPrescription
      ? 'https://schema.org/PrescriptionOnly'
      : isOtc ? 'https://schema.org/OTC' : undefined;
    const manufacturer = product.manufacturer?.name?.trim();
    const activeIngredient = isDrug
      ? (product.ingredients ?? [])
        .filter(ingredient => ingredient?.name?.trim())
        .map(ingredient => [ingredient.name.trim(), ingredient.volume?.trim()].filter(Boolean).join(' '))
        .join(', ')
      : '';

    const schema: Record<string, unknown> = {
      '@context': 'https://schema.org',
      '@type': isDrug ? ['Product', 'Drug'] : 'Product',
      name: product.name?.trim(),
      url: this.getProductUrl(),
      image: (product.imageUrls ?? []).filter(url => url?.trim()),
      category: categories.map(category => category.name.trim()).join(', '),
      brand: manufacturer ? { '@type': 'Brand', name: manufacturer } : undefined,
      manufacturer: manufacturer ? { '@type': 'Organization', name: manufacturer } : undefined,
      description: truncateText(this.getCommonInfoText(), 300),
      activeIngredient,
      prescriptionStatus,
    };
    return Object.fromEntries(Object.entries(schema).filter(([, value]) =>
      value !== undefined && value !== '' && !(Array.isArray(value) && !value.length)));
  }

  async setProductDetail() {
    // this.breadcrumb.items = [];
    const categories = this.product?.categories
      .flatMap((c) => c.name)
      .join('-');
    const slug = this.product?.categories.flatMap((c) => c.slug).join(',');
    this.breadcrumb.items = [];
    this.breadcrumb.items.push({
      label: 'Sản phẩm',
      url: '/product',
      active: false,
    });
    this.breadcrumb.items.push({
      label: this.product?.categories[0]?.name,
      url: `/product?category=${this.product?.categories[0]?.slug}`,
      active: false,
      data: { slug: slug },
    });
    this.breadcrumb.items.push({ label: this.product.name, active: true });
    // this.commonService.setProductDetail(this.product);
    this.product.currentTier = this.product.tieredPrices.find(
      (x: any) => x.pricingTableId == this.product.appliedPricingTable.id,
    );
    // for (let info of this.product.productInfo) {
    //   if (info.type == ProductInfoType.Dosage) {
    //     info.value = this.commonService.getDosageForm(Number(info.value) as DosageForm);
    //   }
    // }

    if (this.product.imageUrls.length == 1) {
      this.productMainThumbSlider.mouseDrag = false;
      this.productMainThumbSlider.touchDrag = false;
      this.productMainThumbSlider.pullDrag = false;
    } else {
      this.productMainThumbSlider.mouseDrag = true;
      this.productMainThumbSlider.touchDrag = true;
      this.productMainThumbSlider.pullDrag = true;
    }

    this.productSuggestions = [];
    this.productSuggestionIds = this.product.productSuggestions?.map(
      (p) => p.productId,
    );

    let body: any = {
      limit: 4,
      offset: 0,
    };

    if (this.isAuthenticated) {
      this.cartSubscription = this.commonService.getCart.subscribe({
        next: async (res: any) => {
          if (res) {
            this.cart = structuredClone(res);
            if (this.product) {
              await this.fetchSuggestions(body);

              this.productSuggestions = this.productSuggestions.slice(0, 4);

              for (let ps of this.productSuggestions) {
                ps.cartItem = this.setCartItem(ps);
              }

              this.product.cartItem = this.setCartItem(this.product);
            }
          }
        },
      });
    } else {
      await this.fetchSuggestions(body);
      this.productSuggestions = this.productSuggestions.slice(0, 4);
    }

    this.wishlistSubscription = this.commonService.getWishlist.subscribe({
      next: (res: number[]) => {
        if (res && res.length > 0 && this.product) {
          this.inWishList = res.includes(this.product.productID);
        }
      },
    });
  }

  setBodyForSuggestions(searchType: string, body: any) {
    switch (searchType) {
      case 'suggestions':
        body = {
          limit: 10,
          offset: 0,
          productIds: this.productSuggestionIds,
        };
        break;
      case 'ingredients':
        body = {
          limit: 10,
          offset: 0,
          ingredients: this.product.ingredients.map((i) => i.name),
        };
        break;
      case 'manufacturers':
        body = {
          limit: 10,
          offset: 0,
          manufacturer: this.product.manufacturer.name,
        };
        break;
    }
    return body;
  }

  async fetchSuggestions(body: any) {
    if (this.productSuggestionIds && this.productSuggestionIds.length > 0) {
      body = this.setBodyForSuggestions('suggestions', body);
      await this.getProductSuggestions(this.isAuthenticated, body);
    }

    if (this.productSuggestions.length < 4) {
      if (this.product.ingredients?.length) {
        body = this.setBodyForSuggestions('ingredients', body);
        await this.getProductSuggestions(this.isAuthenticated, body);
      }
    }

    if (this.productSuggestions.length < 4) {
      if (this.product.manufacturer?.name) {
        body = this.setBodyForSuggestions('manufacturers', body);
        await this.getProductSuggestions(this.isAuthenticated, body);
      }
    }
  }

  async getProductSuggestions(isAuthenticated: boolean, body: any, limit: number = 4) {
    let res: any;
    if (isAuthenticated) {
      res = await firstValueFrom(
        this.productService.getProductsForMember(JSON.stringify(body)),
      );
    } else {
      res = await firstValueFrom(
        this.productService.getProductsPaginationforGuest(JSON.stringify(body)),
      );
    }

    if (res && res.products) {
      const combinedProducts = [...this.productSuggestions, ...res.products];

      const filteredProducts = combinedProducts.filter((item) => {
        const isNotCurrent = item.productID !== this.product.productID;

        if (isAuthenticated) {
          return isNotCurrent && item.basePrice > 0 && item.stockStatus !== 8;
        }
        return isNotCurrent;
      });

      const uniqueProductsMap = new Map();
      filteredProducts.forEach((item) => {
        if (!uniqueProductsMap.has(item.productID)) {
          uniqueProductsMap.set(item.productID, item);
        }
      });
      let finalProducts = Array.from(uniqueProductsMap.values());

      this.productSuggestions = finalProducts.slice(0, limit);
    }
  }

  getPassedData(data: SlidesOutputData) {
    this.activeSlide = data.startPosition!.toString();
  }

  openModal(index: number, productDetailImageModal: any) {
    this.activeSlide = index.toString();
    productDetailImageModal.openModal();
  }

  setSlide(value: any, owlCar: any) {
    this.activeSlide = value;
    owlCar.to(this.activeSlide);
  }

  getVoucher() {
    this.voucherService.availableVouchers$.subscribe({
      next: (res: Voucher[]) => {
        if (!res || !Array.isArray(res)) {
          return;
        }
        this.vouchers = res;
      },
      error: (error: any) => { },
    });
  }

  addToWishlist(id: number) {
    this.inWishList = !this.inWishList;
    const body = {
      productId: id,
    };
    this.wishlistService.addWishlist(JSON.stringify(body)).subscribe({
      next: (res: number[]) => {
        if (res) {
          if (res.some((r) => r == this.product.cartItem.productID)) {
            this.toastService.success('Thêm vào danh sách yêu thích!', '', {
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastService.success('Loại bỏ khỏi danh sách yêu thích!', '', {
              positionClass: 'toast-top-right',
            });
          }
          this.commonService.setWishlist(res);
        }
      },
      error: (error: any) => {
        this.toastService.error('Không thể cập nhật danh sách yêu thích!', '', {
          positionClass: 'toast-top-right',
        });
        console.log(error);
      },
    });
  }

  gotoPolicy(item: any) {
    if (item.direction) {
      this.router.navigateByUrl(item.direction);
    } else return
  }

  ngOnDestroy() {
    this.modalService.dismissAll();
    this.changeQueryStringSubscription?.unsubscribe();
    this.productSubscription?.unsubscribe();
    this.cartSubscription?.unsubscribe();
    this.wishlistSubscription?.unsubscribe();
  }
}
